// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"ce3777a29fbe2e53cd81","477":"732b329640031b9f7d9a"}[chunkId] + ".js";
};